<template>
  <main class="kb-main" id="kb-hrdcloud-v2" style="padding: 15px 0px 15px 15px;" >
    <div class="main-content main-component">
      <slot name="top" />
      <article v-if="sslLicenseList" class="content-section">
        <header class="section-header" style="display: flex;justify-content: space-between;">
          <span class="title">목표 달성 현황</span>
          <div class="mysetting" style="padding-top: 0px;">
            <button class="btn-xs kb-btn-setting" @click="goGoal"><i class="icon-goal"></i>
              <span class="text">목표설정</span>
            </button>
          </div>
        </header>
        <div class="section-body">
          <swiper v-if="sslLicenseList.length > 0"
                  class="hrdcloud-swiper"
                  :modules="modules"
                  slides-per-view="auto"
                  effect="coverflow"
                  :coverflow-effect="{'rotate':0, 'stretch':0, 'depth':100, 'modifier':1, 'slideShadows':false}"
                  :centered-slides="false" >
            <swiper-slide  v-for="(roadmap,idx) in sslLicenseList" :key="idx" class="roadmap-swiper">
              <SSLLicStatusCard
                :data="roadmap"
                @search="doSearch"
              />
            </swiper-slide>
          </swiper>
          <LoadingDiv v-else />
        </div>
      </article>
    </div>
  </main>
</template>

<script>
import {Swiper, SwiperSlide} from 'swiper/vue/swiper-vue';
import LoadingDiv from '@/components/common/LoadingDiv.vue';
import SSLLicStatusCard from '@/components/ssl/lcsn/SSLLicStatusCard.vue';
import {sslLicenseSetup} from "@/assets/js/modules/ssl/setup/ssl-license-setup";
export default {
  name: 'SSLMobileLicStatus',
  components: {
    SSLLicStatusCard, LoadingDiv, Swiper, SwiperSlide},
  props: {
    lrnTrgtGrpMstSn: Number,
  },
  emits: ['search'],
  setup: sslLicenseSetup,
};
</script>
<style>
.mysetting .kb-btn-setting {width:100px;height:38px;margin-right:10px;display:inline-flex;align-items:center;justify-content:center;border-radius: 16px;background-color:#F7F4F0;}
.mysetting .icon-goal {width:32px;height:32px;background-image:url(../../../../assets/lxp/images/talentboard/ic_goal.svg);margin-right:4px;}
.mysetting .text {color:var(--kb-dark-brown);font:normal 16px/20px var(--kb-font-KBFGTextB);}

</style>